<script setup>
import { defineProps, defineEmits } from 'vue';

const props = defineProps({
    label: {
        type: String,
        default: 'Button',
    },
    disabled: {
        type: Boolean,
        default: false,
    },
});

const emit = defineEmits(['click']);

const handleClick = (event) => {
    if (!props.disabled) {
        emit('click', event);
    }
};
</script>

<template>
    <button :disabled="disabled" @click="handleClick">
        <slot>{{ label }}</slot>
    </button>
</template>

<style scoped>
button {
    padding: 0 24px;
    width: 100%;
    background-color: rgba(242, 11, 54, 1);
    color: rgba(255, 255, 255, 1);
    border: 0;
    border-radius: 80px;
    font-weight: 600;
    font-size: 16px;
    line-height: 16px;
    letter-spacing: 0.05px;
    height: 48px;
    cursor: pointer;
    display: inline-grid;
    text-decoration: none;
    place-items: center;

    &:hover {
        background-color: rgba(255, 13, 60, 1);
    }

    &:active {
        background-color: rgba(218, 10, 49, 1);
    }

    &.loading {
        pointer-events: none;
        opacity: 0.25;
        background-color: rgba(255, 13, 60, 1);
    }

    &:disabled {
        opacity: 0.5;
        cursor: not-allowed;
        user-select: none;
        background-color: rgba(242, 11, 54, 1);
    }
}
</style>
